module.exports = __webpack_public_path__ + "assets/img/IMG023.fdbb07b8.png";